import styles from './Toast.styles'
import CloseIcon from '@mui/icons-material/Close'
import ButtonSecondary from 'components-new/inputs/Button/ButtonSecondary'
import { FormattedMessage } from 'react-intl'
import intl from 'localization/components'
import { Typography } from '@mui/material'

type ToastProps = {
  onClose: () => void
  onSubmit: () => void
  message: string
  isVisible: boolean
  usage?: string
  total?: string
}

export const Toast = (props: ToastProps) => {
  const { onClose, onSubmit, message, isVisible, usage, total } = props
  const { container, show, hide, closeButton, description, contentContainer } = styles

  const combinedStyle = {
    ...container,
    ...(isVisible ? show : hide),
  }

  return (
    <div style={combinedStyle}>
      <div style={contentContainer}>
        <Typography variant="subtitle1" style={description}>
          <FormattedMessage
            id={intl.generic(message)}
            values={{ usage: usage, total: total }}
          />
        </Typography>

        <ButtonSecondary onClick={onSubmit}>
          <FormattedMessage id={intl.generic('upgrade')} />
        </ButtonSecondary>
      </div>
      <CloseIcon onClick={onClose} sx={closeButton} fontSize="large" />
    </div>
  )
}
